import React, { useState } from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

const WireTransfer = ({ bank }) => {
  const { t } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const [copy, setCopy] = useState("");

  return (
    <>
      <Card className="shadow p-3" bg="dark1 text-light mb-3">
        <Card.Body>
          {bank.beneficiary && (
            <>
              <Form.Label>{t("beneficiary")}:</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control disabled={true} value={bank?.beneficiary} />
                <CopyToClipboard
                  text={bank?.beneficiary}
                  onCopy={() => setCopy()}
                >
                  <Button variant="outline-secondary">
                    <i className="fa fa-copy"></i>
                  </Button>
                </CopyToClipboard>
              </InputGroup>
            </>
          )}

          {bank.postal_bulletin_number !== 0 && (
            <>
              <Form.Label>{t("postal_number")}:</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control
                  disabled={true}
                  value={bank?.postal_bulletin_number}
                />
                <CopyToClipboard
                  text={bank?.postal_bulletin_number}
                  onCopy={() => setCopy()}
                >
                  <Button variant="outline-secondary">
                    <i className="fa fa-copy"></i>
                  </Button>
                </CopyToClipboard>
              </InputGroup>
            </>
          )}

          {bank.iban && (
            <>
              <Form.Label>IBAN:</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control disabled={true} value={bank?.iban} />
                <CopyToClipboard text={bank?.iban} onCopy={() => setCopy()}>
                  <Button variant="outline-secondary">
                    <i className="fa fa-copy"></i>
                  </Button>
                </CopyToClipboard>
              </InputGroup>
            </>
          )}

          {bank.bank_name && (
            <>
              <Form.Label>{t("bank")}:</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control disabled={true} value={bank?.bank_name} />
                <CopyToClipboard
                  text={bank?.bank_name}
                  onCopy={() => setCopy()}
                >
                  <Button variant="outline-secondary">
                    <i className="fa fa-copy"></i>
                  </Button>
                </CopyToClipboard>
              </InputGroup>
            </>
          )}

          {bank.swift && (
            <>
              <Form.Label>SWIFT/BIC:</Form.Label>
              <InputGroup className="mb-3">
                <Form.Control disabled={true} value={bank?.swift} />
                <CopyToClipboard text={bank?.swift} onCopy={() => setCopy()}>
                  <Button variant="outline-secondary">
                    <i className="fa fa-copy"></i>
                  </Button>
                </CopyToClipboard>
              </InputGroup>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default WireTransfer;
